import { React, useRef, useEffect, useState } from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AlertDialog from '../Modals/AlertDialog'
import ErrorIcon from '@mui/icons-material/Error';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import StyledRadio from '../StyledExtensions/StyledRadio'
import Paper from '@mui/material/Paper';
import CalculateIcon from '@mui/icons-material/Calculate';

export default function CountOrEstimator(props) {
    const [value, setValue] = useState(props.pickupRequest.Quantifier !== undefined ? props.pickupRequest.Quantifier : '');
    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    function isValidated() {
        if (value !=='') {
            return true;
        }

        return false;
    }

    function showMoreInfo(infoType) {
        if (infoType == 'Count') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                <div style={{ display: 'flex' }}>
                    <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                    <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                        <div style={{ marginTop: '10px', fontSize:'16pt',fontWeight:'bold' }}>Exact Count</div>
                        <div style={{ marginTop: '10px' }}>If you know the exact amount of your cans & bottles, then please select this option.</div>
                    </div>
                </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'Estimate') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Estimate Count</div>
                            <div style={{ marginTop: '10px' }}>If you do not know the exact count, you can provide an estimate using our built in tool without getting your hands dirty.</div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
    }

    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={styles.cardHeader}>How man cans/bottles do you have?</div>

            <div style={{ marginTop: '15px' }}>
                Our returners do not count your returnables - you are paid for the quantity you submit. Our ability to provide service is based on a mutual trust between local returners and the communities they serve.
            </div>

            <div style={{ marginTop: '15px' }}>
                Please do your best to include cans & bottles that can be returned at major retail locations such as Meijer, Walmart, Kroger, Aldi, Family Fare, Save A Lot, Costco, etc.
            </div>

            <div style={{ marginTop: '15px' }}>
                If you indicate you have more cans & bottles than the actual amount, it will cost your returner money.
            </div>

            <div style={{ marginTop: '15px' }}>
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                    >
                        <Paper elevation={5} >
                            <div style={{ display: 'flex' }}>
                                <IconButton aria-label="More Info" onClick={() => showMoreInfo('Count')} style={{ marginRight: '10px' }}>
                                    <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                </IconButton>
                                <FormControlLabel value="Count" control={<StyledRadio checked={value === 'Count'} onChange={(e) => setValue(e.target.value)} />} label="I will provide my exact can & bottle count" />
                            </div>
                        </Paper>
                        <Paper elevation={5} style={{marginTop:'15px'} } >
                        <div style={{ display: 'flex' }}>
                            <IconButton aria-label="More Info" onClick={() => showMoreInfo('Estimate')} style={{marginRight:'10px'} }>
                                <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                            </IconButton>
                                <FormControlLabel value="Estimate" control={<StyledRadio checked={value === 'Estimate'} onChange={(e) => setValue(e.target.value)} />} label={<span>I will use the Sipzee ESTIMATOR TOOL  <CalculateIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} /></span>} />
                            </div>
                        </Paper>
                    </RadioGroup>
                </FormControl>
            </div>

            <div style={{ marginTop: '15px', backgroundColor: 'var(--sipzee-yellow-2)', padding: '10px', display:'flex' }}>
                <CalculateIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 40 }} />
                ESTIMATOR TOOL - This option is designed to save you the headache of counting cans & bottles while ensuring your Recycler does not lose money on your pickup. If you have returnables sprinkled in that may not be recycled at a major retail location, that is okay.
                YOU WILL BE PAID BASED ON THE ESTIMATED VALUE.
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                    <Button variant={isValidated() ? "contained" : "outlined"} color="sipzeeGreen" disabled={!isValidated()} onClick={() => props.onNext(value)}>Next <KeyboardArrowRight /></Button>
                </div>
            </div>
            <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />
        </div>    
    );
}